<!--
  预约办卡
  lovi 2020-06-16
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('wallet.reservationHandleCard')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    >
      <span slot="right" @click="_linkFun('/record?flag=4')">
        {{ $t("common.reservationRecord") }}
      </span>
    </van-nav-bar>
    <div class="scroll-wrapper">
      <van-cell-group>
        <van-field
          v-model="name"
          :label="$t('common.name')"
          :placeholder="$t('common.enterName')"
          clearable
        />
        <van-field
          v-model="phone"
          :label="$t('common.mobileNumber')"
          :placeholder="$t('common.enterMobile')"
          type="tel"
          :error="error.phone ? true : false"
          :maxlength="telMax"
          :formatter="_phoneFormat"
          @input="changeCellphone"
          clearable
        />
      </van-cell-group>
      <div class="button-wrap">
        <van-button block type="primary" :loading="btnLoading" @click="submit">
          {{ $t("withdraw.submitForAudit") }}
        </van-button>
        <p class="tips">
          {{ $t("wallet.reservationHandleCardTips") }}
        </p>
      </div>
    </div>

    <transition name="slide">
      <detail
        v-if="datailFlag"
        :datailFlag.sync="datailFlag"
        :data="detailData"
      />
    </transition>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
import Detail from "./detail";
export default {
  name: "appointment",
  components: {
    Detail
  },
  data() {
    return {
      name: "",
      phone: "",
      telMax: 13,
      error: {
        phone: false
      },
      btnLoading: false,
      datailFlag: false,
      detailData: {}
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    changeCellphone(value) {
      // 校验手机号
      console.log("phone", value);
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        this.telMax1 = 13;
      } else {
        //否则输入框最多输入12位
        this.telMax1 = 12;
      }
      let phone = value.replace(/\s/g, "");
      this.error.phone = validate.validateMobile(phone);
    },
    submit() {
      // 提交审核
      let vm = this;
      if (vm.name == "") {
        vm.$toast(vm.$t("common.enterName"));
        return false;
      }
      if (vm.phone == "") {
        vm.$toast(vm.$t("common.enterMobile"));
        return false;
      }
      console.log(vm.error);
      if (vm.error.phone) {
        vm.$toast(vm.error.phone);
        return false;
      }
      let params = {};
      params.name = vm.name;
      params.phone = "0" + Number(vm.phone.replace(/\s/g, ""));
      vm.btnLoading = true;
      vm.$post("/app/user/appointmentCard", params, {
        loading: true,
        alert: true
      }).then(res => {
        console.log("appointmentCard", res);
        vm.btnLoading = false;
        if (res.code == 0) {
          vm.datailFlag = true;
          vm.detailData = res.data;
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
/deep/.van-cell {
  .van-cell__title {
    width: auto;
    flex: initial;
    margin-right: 10px;
  }
}
</style>
